import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "src/components/common/functions";

export type DocumentItem = {
    id: string;
    name: string;
    type: string;
    size: number;
    parentId: string | null;
    description: string;
    webViewLink: string;
};

export type DocumentLoaderData = {
    title: string;
    rootFolderId: string;
    currentFolderId: string;
    files: DocumentItem[];
    parents: { id: string; name: string }[];
};

export function makeDocumentsLoader(rootFolderId: string, title: string) {
    return async function documentsLoader({ params }: LoaderFunctionArgs): Promise<DocumentLoaderData> {
        const folderId = params.folderId || rootFolderId;
        const formData = new FormData();
        formData.append("folderId", folderId);
        formData.append("rootFolderId", rootFolderId);
        const res = await myAxios({
            fileName: "documents/readFolder.php",
            formData,
        });
        if (!res) throw redirect("..");
        return {
            title,
            rootFolderId,
            currentFolderId: folderId,
            files: res.data.files ?? [],
            parents: res.data.parents ?? [],
        };
    };
}

export function makeDocumentsAction() {
    return async function documentsAction({ request, params }: ActionFunctionArgs) {
        const controller = new AbortController();
        request.signal.addEventListener("abort", () => {
            controller.abort();
        });
        const formData = await request.formData();
        const kind = params.kind;
        const map = {
            createFolder: "documents/createFolder.php",
            createLink: "documents/createLink.php",
            rename: "documents/renameFile.php",
            delete: "documents/deleteFile.php",
        } as const;
        const fileName = kind ? map[kind as keyof typeof map] : undefined;
        if (!fileName) {
            throw new Response("Invalid action", { status: 400 });
        }
        const res = await myAxios({
            fileName,
            formData,
            signal: controller.signal,
        });
        if (!res) throw redirect("..");
        throw redirect("..");
    };
}

